import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const ProductEmptyState = {
  products: [],
  selectedProduct: null,
  selectedProductMultiple: [],
};

export const ProductKey = 'products';

export const productsSlice = createSlice({
  name: 'products',
  initialState: getLocalStorage(LocalStorageTypes.PRODUCTS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.PRODUCTS))
    : ProductEmptyState,
  reducers: {
    setProducts: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.PRODUCTS, result);
      return { ...state, ...action.payload };
    },
    updateSelectedProduct: (state, action) => {
      const result = { ...state, selectedProduct: action.payload };
      persistLocalStorage(ProductKey, result);
      return result;
    },
    updateSelectedProductMultiple: (state, action) => {
      const result = { ...state, selectedProductMultiple: action.payload };
      persistLocalStorage(ProductKey, result);
      return result;
    },
    resetProducts: () => {
      clearLocalStorage('products');
      return ProductEmptyState;
    },
  },
});

export const {
  setProducts,
  updateSelectedProduct,
  updateSelectedProductMultiple,
  resetProducts,
} = productsSlice.actions;
